export const MINIMAL_GAMES_FOR_TWO_ROWS_VIEW = 12
